import { Component, OnInit, ViewChild } from '@angular/core';
import * as ngswal from "sweetalert";
import { Local } from 'protractor/built/driverProviders';
import { ApiMethod } from '../apimethods/api-method';
import { DataParam, customfunctions } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { weightagesendapprovalModel } from './weightage-sendapprovalmodel';

declare var $;


@Component({
  selector: 'app-weightage-sendapproval',
  templateUrl: './weightage-sendapproval.component.html',
  styleUrls: ['./weightage-sendapproval.component.css']
})
export class weightagesendapprovalComponent implements OnInit {

  modelItem = new weightagesendapprovalModel();
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
  title: string;
  popupButtonText: string;
  showModal: boolean;
  RoleList: any;
  username: string;

  ngOnInit() {


  }

  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <weightagesendapprovalModel>data["weightageSendapprovalPage"];

        $('#ddlApprovedStatus').select2({
          placeholder: "Select Status",
          dropdownParent: "#divMainFilter"
        });
        $('#ddlApprovedStatus').val([]).trigger('change');

        $('#ddlOldRoleType').select2({
          placeholder: "Select Role",
          dropdownParent: "#btnPopupartDetails"
        });
        $('#ddlOldRoleType').val([]).trigger('change');

        $('#ddlNewRoleType').select2({
          placeholder: "Select Role",
          dropdownParent: "#btnPopupartDetails"
        });
        $('#ddlNewRoleType').val([]).trigger('change');

        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");

        this.GetRoleList();
        this.GetweightageApprovalData();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }



  //Get RoleList
  GetRoleList(): void {
    ApiMethod.getMethod(this.modelItem.RoleListAPI).subscribe(
      result => {
        this.RoleList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  resetFilter() {
    $("#ddlApprovedStatus").val(0).change();
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    this.GetweightageApprovalData();
  }

  GetweightageApprovalData(): void {

    $("#LoadingImage").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "WeightageApproval",
      ApprovedStatus: $("#ddlApprovedStatus").val() ,
      FromDate: $("#Txt_FromDate").val(),
      ToDate: $("#Txt_ToDate").val()
    }
    ApiMethod.postMethod(this.modelItem.weightageApprovalListAPI, dataParam).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 180);
        dataItem.modulename = 'WeightageApproval';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Show Publisher details by ID
  showWeightageApproval(): void {
    $("#LoadingImagePopup").show();
    this.ClearData();

    if (localStorage.aEID && localStorage.aEID !== "0") {
      $("#btnPopupartDetails").show();
      this.popupButtonText = "Update";

      ApiMethod.getMethod(this.modelItem.weightageApprovalIDAPI + localStorage.aPubID + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          const aitems = result.aitemList;
          if (aitems && aitems.length > 0) {
            const data = aitems[0];
            if (data.ApprovedStatus == "Approved" || data.ApprovedStatus == "Waiting for Approval") {
              //$("input[type='number']").prop("disabled", true);
              //$("#ddlNewRoleType").prop("disabled", true); 
              $("#btnupdate").hide(); 
              
            }

            if (data.ApprovedStatus === "Need More Info" || data.ApprovedStatus === "Send to Approval") {
             
              $("#Requestnote").hide();
              if (data.ApproverNote != null && data.ApproverNote !== "") {
                $("#Requestnote").show();
                $("#Responcenote").show();
                $('#Txt_RequestNote').val(data.ApproverNote);
              }
             
            }

            // Old Weightage
            $("#ddlOldRoleType").val(data.Old_RoleId).change();

            // Set Old Weightage performance fields
            $('#Txt_ResponceNote').val(data.BUHeadNote);
            $('#Txt_RequestNote').val(data.ApproverNote);
            $('#Txt_OldNonProduction').val(data.Old_NonProduction);
            $('#Txt_OldProductivityAchieved').val(data.Old_ProductivtyAchieved);
            $('#Txt_OldOccupancy').val(data.Old_Occupancy);
            $('#Txt_OldPunctuality').val(data.Old_Punctuality);
            $('#Txt_OldAttendance').val(data.Old_Attendance);
            $('#Txt_OldTotalSum').val(data.Old_TotalSum);
            $('#Txt_OldDailyTargetPages').val(data.Old_DailyTargetPages);

            // New Weightage
            $("#ddlNewRoleType").val(data.New_RoleId).change();

            // Set New Weightage performance fields
            $('#Txt_NewNonProduction').val(data.New_NonProduction);
            $('#Txt_NewProductivityAchieved').val(data.New_ProductivtyAchieved);
            $('#Txt_NewOccupancy').val(data.New_Occupancy);
            $('#Txt_NewPunctuality').val(data.New_Punctuality);
            $('#Txt_NewAttendance').val(data.New_Attendance);
            $('#Txt_NewTotalSum').val(data.New_TotalSum);
            $('#Txt_NewDailyTargetPages').val(data.New_DailyTargetPages);
            $('#Txt_Comment').val(data.BUHeadComment);



            // Delay to ensure DOM update before reading selected text
            setTimeout(() => {
              this.title = `Weightage Approval`;
              this.username = data.LoginName;
            }, 0);
          }
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
    } else {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.weightageSendApprovalAPI + localStorage.aPubID + '/' + localStorage.aLoginID).subscribe(
        result => {
          if (result.status) {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Thank You !",
              text: result.message,
              showConfirmButton: false,
              timer: 1500
            });
            this.GetweightageApprovalData();
          } else {
            ngswal({
              position: 'top-end',
              type: "error",
              title: "Failed !",
              text: result.message || "An error occurred. Please try again later.",
              showConfirmButton: true
            });
          }
          $("#LoadingImage").hide();
        },
        error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.error.Message, "warning");
        });
    }
  }

  calculateTotal(lastFieldId: string): void {
    const fields = [
      'Txt_NewNonProduction',
      'Txt_NewProductivityAchieved',
      'Txt_NewOccupancy',
      'Txt_NewPunctuality',
      'Txt_NewAttendance',
      //'Txt_LD_Training',
      //'Txt_APQC_Skills',
      //'Txt_DeliverRCA_Skills'
    ];

    let total = 0;
    let allFieldsFilled = true;

    // First calculate total normally
    for (let fieldId of fields) {
      const input = document.getElementById(fieldId) as HTMLInputElement;
      if (input && input.value.trim() !== '') {
        const value = parseFloat(input.value);
        total += isNaN(value) ? 0 : value;
      } else {
        allFieldsFilled = false;
      }
    }

    const totalField = document.getElementById('Txt_NewTotalSum') as HTMLInputElement;
    const lastInput = document.getElementById(lastFieldId) as HTMLInputElement;

    // If there's an error
    if (total > 100 || (allFieldsFilled && total < 100)) {
      // Remove the last entered value
      if (lastInput) lastInput.value = '';

      // Recalculate total without the last field
      let newTotal = 0;
      for (let fieldId of fields) {
        if (fieldId === lastFieldId) continue;
        const input = document.getElementById(fieldId) as HTMLInputElement;
        if (input && input.value.trim() !== '') {
          const value = parseFloat(input.value);
          newTotal += isNaN(value) ? 0 : value;
        }
      }

      // Set the new total
      if (totalField) totalField.value = newTotal.toFixed(2);

      // Show warning
      ngswal("Warning !", total > 100 ? "Total cannot exceed 100!" : "Total must be exactly 100!", "warning");
      return;
    }

    // If no error, update total as normal
    if (totalField) {
      totalField.value = total.toFixed(2);
    }
  }


  //Update Weightage Rolewise details
  UpdateWeightageApproval(): void {
    // Validate RoleType
    if ($('#ddlNewRoleType').val() == null) {
      ngswal("Warning !", "Enter Role name!", "warning");
      return;
    }

    // Validate NonProduction
    //if ($('#Txt_NewNonProduction').val() == '') {
    //  ngswal("Warning !", "Enter NonProduction value!", "warning");
    //  return;
    //}

    // Validate ProductivtyAchieved
    if ($('#Txt_NewProductivityAchieved').val() == '') {
      ngswal("Warning !", "Enter Productivity Achieved value!", "warning");
      return;
    }

    // Validate Occupancy
    if ($('#Txt_NewOccupancy').val() == '' || $('#Txt_NewOccupancy').val() == 0) {
      ngswal("Warning !", "Enter Occupancy value!", "warning");
      return;
    }

    if ($('#Txt_NewPunctuality').val() == '' || $('#Txt_NewPunctuality').val() == 0) {
      ngswal("Warning !", "Enter Punctuality value!", "warning");
      return;
    }

    if ($('#Txt_NewAttendance').val() == '' || $('#Txt_NewAttendance').val() == 0) {
      ngswal("Warning !", "Enter Attendance value!", "warning");
      return;
    }
    if ($('#Txt_NewDailyTargetPages').val() == '' || $('#Txt_NewDailyTargetPages').val() == 0) {
      ngswal("Warning !", "Enter Attendance value!", "warning");
      return;
    }

    //if ($('#Txt_LD_Training').val() == '' || $('#Txt_LD_Training').val() == 0) {
    //  ngswal("Warning !", "Enter LD Training value!", "warning");
    //  return;
    //}

    //if ($('#Txt_APQC_Skills').val() == '' || $('#Txt_APQC_Skills').val() == 0) {
    //  ngswal("Warning !", "Enter APQC Skills value!", "warning");
    //  return;
    //}

    //if ($('#Txt_DeliverRCA_Skills').val() == '' || $('#Txt_DeliverRCA_Skills').val() == 0) {
    //  ngswal("Warning !", "Enter Deliver RCA Skills value!", "warning");
    //  return;
    //}
    // If all validations pass, show the loading popup
    $("#LoadingImagePopup").show();

    // Gather all values from the UI and map to the Dataitem object
    var Dataitem = {
      Id: localStorage.aEID,
      RoleId: $("#ddlNewRoleType").val(),
      PublisherId: 0,
      NonProduction: parseFloat($("#Txt_NewNonProduction").val() || '0'),
      ProductivtyAchieved: parseFloat($("#Txt_NewProductivityAchieved").val() || '0'),
      Occupancy: parseFloat($("#Txt_NewOccupancy").val() || '0'),
      Punctuality: parseFloat($("#Txt_NewPunctuality").val() || '0'),
      Attendance: parseFloat($("#Txt_NewAttendance").val() || '0'),
      LD_Training: 0,
      APQC_Skills: 0,
      DeliverRCA_Skills: 0,
      TotalSum: parseFloat($("#Txt_NewTotalSum").val() || '0'),
      DailyTargetPages: $("#Txt_NewDailyTargetPages").val() || '0',
      UpdatedBy: localStorage.aLoginID,
      BUHeadNote: $("#Txt_ResponceNote").val(),
      BUHeadComment: $("#Txt_Comment").val()
    };
    ApiMethod.postMethod(this.modelItem.weightageApprovalUpdateAPI, Dataitem).subscribe(
      response => {

        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.hide();
          this.GetweightageApprovalData();
        } else {
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Failed !",
            text: response.message || "An error occurred. Please try again later.",
            showConfirmButton: true
          });
        }

        $("#LoadingImagePopup").hide();

      },
      error => {
        ngswal("Failed!", error.error.Message, "error");
        $("#LoadingImagePopup").hide();
      }
    );
  }



  ClearData(): void {
    $("input[type='text']").val("");
    $("input[type='number']").val("");
    $("#ddlNewRoleType").val(0).change();
    $("#ddlOldRoleType").val(0).change();
    $("#btnupdate").show();
    $("#Responcenote").hide();
    $("#Requestnote").hide();
    //$("input[type='number']").prop("disabled", false);
    //$("#ddlNewRoleType").prop("disabled", false); 


  }
  hide(): void {
    $("#btnPopupartDetails").hide();
  }


}

